import { Component, Host, h, Prop } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../utils/helpers';

@Component({
  tag: 'vds-interactive-link',
  styleUrl: 'vds-interactive-link.scss',
  shadow: true,
})
export class VdsInteractiveLink {

  /**
   * Specifies the URL of the page the link goes to
   */
  @Prop() href: string;

  /**
   * Specifies where to open the linked document
   */
  @Prop() target: HTMLAnchorElementTarget = '_self';

  /**
   * Sets the download attribute for the underlying anchor element
   */
  @Prop() download: boolean = false;

  /**
   * Applies highlight and underline decoration
   */
  @Prop({ mutable: true, reflect: true }) active: boolean = false;

  /**
   * Highlights the link if set to true
   */
  @Prop({ mutable: true, reflect: true }) selected: boolean = false;

  /**
   * Removes the underline if set to true (e.g. for icon links)
   */
  @Prop({ mutable: true, reflect: true }) noDecoration: boolean = false;

  /**
   * Specifies that the element should be disabled
   */
  @Prop({ mutable: true, reflect: true }) disabled: boolean = false;

  render() {
    const { href, target, active, selected, noDecoration, disabled } = this;

    return (
      <Host>
        <a ref={ref => this.setAttributes(ref)}
           href={href}
           target={target}
           class={{
            'active': active || selected,
            'no-decoration': noDecoration,
            'disabled': disabled
        }}>
          <slot></slot>
        </a>
      </Host>
    );
  }

  private setAttributes(el: HTMLAnchorElement): void {
    if (this.download) {
      el.setAttribute('download', '');
    }
  }

}
